export interface ReportDetails {
    reportName: string;
    reportType: string;
    reportTypeEnum: ReportTypes;
    recordId: string;
    postId: string;
    userId: string;
    createdTime: Date;
    downloadedBy: string | null;
    downloadedTime: Date | null;
}

export enum ReportTypes {
    UserReadReport = 'UserReadReport',
    AnalyticsCsvReport = 'AnalyticsCsvReport',
    PlatformAnalyticsReport = 'PlatformAnalyticsReport',
    SMSNotificationReport = 'SMSNotificationReport',
    EmailActivityReport = 'EmailActivityReport',
    SMSActivityReport = 'SMSActivityReport',
    SMSConsentReport = 'SMSConsentReport',
    TopicSubscribersReport = 'TopicSubscribersReport',
    TopicContributorsReport = 'TopicContributorsReport',
    TopicAuthorsReport = 'TopicAuthorsReport',
    TopicAllReport = 'TopicAllReport',
    AllAudienceAnalyticsReports = 'AllAudienceAnalyticsReports',
    AudienceAnalyticsByLanguageReport = 'AudienceAnalyticsByLanguageReport',
    AudienceAnalyticsByChannelReport = 'AudienceAnalyticsByChannelReport',
    AudienceTrendsReport = 'AudienceTrendsReport',
    MobileUserDataReport = 'MobileUserDataReport'
}